/**
 * Eigenbau: Prüfquadrat der Akzeptanzkriterien — 15×15, keine Rundung.
 *
 * Der Entwurf zeigt Erfüllt als gefülltes Quadrat in Tinte mit Papier-Haken,
 * Offen als leeres Quadrat mit Haarlinie. Beim Überfahren wird die Haarlinie
 * zum Akzent — die einzige Bewegung, die der Entwurf dem Kriterium erlaubt.
 */

import { cx, focusRing } from "@/lib/utils";

export function Pruefquadrat({
  erfuellt,
  onKlick,
  ariaLabel,
  disabled = false,
  className,
}: {
  erfuellt: boolean;
  onKlick?: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={erfuellt}
      aria-label={ariaLabel}
      onClick={onKlick}
      disabled={disabled}
      className={cx(
        "flex size-[15px] flex-none items-center justify-center transition-shadow duration-150 ease-aus",
        erfuellt
          ? "bg-tinte"
          : "shadow-[inset_0_0_0_1px_var(--tinte4)] hover:shadow-[inset_0_0_0_2px_var(--akzent)]",
        "disabled:cursor-not-allowed disabled:opacity-40",
        focusRing,
        className,
      )}
    >
      {erfuellt ? (
        <svg
          width="9"
          height="9"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--papier)"
          strokeWidth="4"
          strokeLinecap="square"
          aria-hidden="true"
        >
          <path d="M20 6 9 17l-5-5" />
        </svg>
      ) : null}
    </button>
  );
}
